export function generateRandom(): number {
    const crypto = window.crypto || Crypto;
    let array = new Uint32Array(1);
    if ("getRandomValues" in crypto) {
        crypto.getRandomValues(array);
    }
    let value = array[0];
    return Math.floor(value);
}